import { render, staticRenderFns } from "./StudentClassCursusAddEdit.vue?vue&type=template&id=114a61e6"
import script from "./StudentClassCursusAddEdit.vue?vue&type=script&lang=js"
export * from "./StudentClassCursusAddEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports